module.exports = __webpack_public_path__ + "static/img/browse_1.bc740cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/browse_1.png
// module id = dYPK
// module chunks = 1